import React from 'react';
import {ArrowLeft} from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8 md:p-12">
        <Link to="/" className="inline-flex items-center text-green-700 hover:text-green-800 mb-8 transition-colors">
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar ao Site
        </Link>

        <h1 className="text-4xl font-bold text-gray-900 mb-2">Termos de Serviço</h1>
        <p className="text-sm text-gray-500 mb-8">Última atualização: {new Date().toLocaleDateString('pt-PT')}</p>

        <div className="prose prose-lg max-w-none space-y-8">
          {/* Seção 1 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Termos</h2>
            <p className="text-gray-700">
              Ao aceder ao website Pinhacorada, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis. Se não concordar com algum destes termos, está proibido de usar ou aceder a este website. Os materiais contidos neste website são protegidos pelas leis de direitos autorais e marcas comerciais aplicáveis.
            </p>
          </section>

          {/* Seção 2 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Uso de Licença</h2>
            <p className="text-gray-700 mb-4">
              É concedida permissão para descarregar temporariamente uma cópia dos materiais (informações ou software) no site Pinhacorada, apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, não pode:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Modificar ou copiar os materiais;</li>
              <li>Usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial);</li>
              <li>Tentar descompilar ou fazer engenharia reversa de qualquer software contido no site Pinhacorada;</li>
              <li>Remover quaisquer direitos autorais ou outras notações de propriedade dos materiais;</li>
              <li>Transferir os materiais para outra pessoa ou 'espelhar' os materiais em qualquer outro servidor.</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Esta licença será automaticamente rescindida se violar alguma dessas restrições e poderá ser rescindida pela Pinhacorada a qualquer momento. Ao encerrar a visualização destes materiais ou após o término desta licença, deve apagar todos os materiais descarregados em sua posse, seja em formato eletrónico ou impresso.
            </p>
          </section>

          {/* Seção 3 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Isenção de Responsabilidade</h2>
            <p className="text-gray-700 mb-4">
              Os materiais no site Pinhacorada são fornecidos 'como estão'. A Pinhacorada não oferece garantias, expressas ou implícitas e, por este meio, isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual ou outra violação de direitos.
            </p>
            <p className="text-gray-700">
              Além disso, a Pinhacorada não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ou à confiabilidade do uso dos materiais no seu site ou de outra forma relacionado com estes materiais ou em sites vinculados a este site.
            </p>
          </section>

          {/* Seção 4 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitações</h2>
            <p className="text-gray-700 mb-4">
              A Pinhacorada e os seus fornecedores nunca serão responsáveis por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro ou devido a interrupção de negócios) decorrentes do uso ou da incapacidade de usar os materiais do website Pinhacorada, mesmo que a Pinhacorada ou um representante autorizado da Pinhacorada tenha sido notificado oralmente ou por escrito da possibilidade de tais danos.
            </p>
            <p className="text-gray-700">
              Como algumas jurisdições não permitem limitações em garantias implícitas ou limitações de responsabilidade por danos consequentes ou incidentais, essas limitações podem não se aplicar no seu caso.
            </p>
          </section>

          {/* Seção 5 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Precisão dos Materiais</h2>
            <p className="text-gray-700 mb-4">
              Os materiais exibidos no site Pinhacorada podem incluir erros técnicos, tipográficos ou fotográficos. A Pinhacorada não garante que qualquer material no seu site seja preciso, completo ou atual.
            </p>
            <p className="text-gray-700">
              A Pinhacorada pode fazer alterações nos materiais contidos no seu site a qualquer momento, sem aviso prévio. No entanto, a Pinhacorada não se compromete a atualizar os materiais.
            </p>
          </section>

          {/* Seção 6 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Links</h2>
            <p className="text-gray-700 mb-4">
              A Pinhacorada não analisou todos os sites vinculados ao seu site e não é responsável pelo conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica uma recomendação por parte da Pinhacorada sobre o conteúdo que irá obter ao aceder ao link.
            </p>
            <p className="text-gray-700">
              O uso de qualquer site vinculado será sempre realizado por sua conta e risco, na qualidade de utilizador final.
            </p>
          </section>

          {/* Seção 7 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Serviços Prestados</h2>
            <p className="text-gray-700 mb-4">
              A Pinhacorada é uma empresa especializada em silvicultura preventiva e manutenção de espaços verdes, oferecendo os seguintes serviços:
            </p>
            <div className="bg-green-50 p-6 rounded-lg">
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Manutenção de Espaços Verdes</li>
                <li>Controlo da Vegetação Espontânea</li>
                <li>Instalação e Beneficiação de Povoamentos Florestais</li>
                <li>Valorização Ambiental de Espaços Florestais</li>
                <li>Instalação e Beneficiação de Infraestruturas Florestais</li>
                <li>Podas e Abates de Árvores com Recurso a Escalada</li>
                <li>Manutenção de Faixas de Gestão de Combustível</li>
              </ul>
            </div>
            <p className="text-gray-700 mt-4">
              Os pedidos de orçamento submetidos através do formulário de contacto não constituem uma proposta vinculativa. Todos os orçamentos são elaborados de forma personalizada e a contratação dos serviços apenas se considera efetiva após aceitação formal do orçamento por ambas as partes.
            </p>
          </section>

          {/* Seção 8 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Modificações</h2>
            <p className="text-gray-700">
              A Pinhacorada poderá atualizar estes termos de serviço do website a qualquer momento, sem aviso prévio. Ao usar este website, concorda em ficar vinculado à versão atual destes termos de serviço.
            </p>
          </section>

          {/* Seção 9 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Lei Aplicável</h2>
            <p className="text-gray-700">
              Estes termos de serviço são regidos e interpretados de acordo com a legislação Portuguesa e, como utilizador final, submete-se irrevogavelmente à jurisdição exclusiva dos tribunais do distrito ou comarca da sede fiscal da Pinhacorada em Mortágua, Portugal.
            </p>
          </section>

          {/* Seção 10 */}
          <section className="border-t pt-6">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contactos</h2>
            <p className="text-gray-700 mb-4">
              Para questões relacionadas com estes Termos de Serviço, contacte-nos:
            </p>
            <div className="bg-gray-900 text-white p-6 rounded-lg">
              <p className="mb-2"><strong>Pinhacorada</strong></p>
              <p className="mb-2">📍 Mortágua, Portugal</p>
              <p className="mb-2">📧 Email: <a href="mailto:pinhacorada@gmail.com" className="underline hover:text-green-400">pinhacorada@gmail.com</a></p>
              <p>📞 Telefone: 965 812 210</p>
            </div>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t">
          <Link to="/" className="inline-flex items-center text-green-700 hover:text-green-800 transition-colors font-semibold">
            <ArrowLeft className="h-5 w-5 mr-2" />
            Voltar ao Site
          </Link>
        </div>
      </div>
    </div>
  );
}
